import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { Button } from '@lt/components';

import { i18n } from '@lt/localization';
import { getFlightClass } from 'checkout/store/selectors/view';
import { FLIGHT_CLASSES } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/constants';
import {
  economyFlightsCountSelector,
  businessFlightsCountSelector,
} from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/selectors';
import type { FlightClass } from '../../types/flights';
import { changeFlightClassAction } from '../../store/flights/slice';

interface FlightClassSwitcherProps {
  flightClass: FlightClass;
  economyCount: number;
  businessCount: number;
  setFlightClass: (flightClass: FlightClass) => void;
}

class FlightClassSwitcher extends React.PureComponent<FlightClassSwitcherProps> {
  constructor(props) {
    super(props);

    this.handleClassChange = this.handleClassChange.bind(this);
  }

  handleClassChange(event) {
    const { id: classType } = event.target;
    const { setFlightClass } = this.props;
    setFlightClass(classType);
  }

  render() {
    const { flightClass, economyCount, businessCount } = this.props;
    const hasEconomy = economyCount > 0;
    const hasBusiness = businessCount > 0;
    return (
      <div className="flight-class-switcher">
        <Button
          functional
          id={FLIGHT_CLASSES.ECONOMY}
          onClick={this.handleClassChange}
          disabled={!hasEconomy}
          className={cn('flight-class', {
            'flight-class--active': flightClass === FLIGHT_CLASSES.ECONOMY,
          })}
        >
          {`${
            hasEconomy
              ? i18n.t('checkout.flight.economy.title')
              : i18n.t('checkout.flight.economy.noTicket')
          }`}
        </Button>
        {' · '}
        <Button
          functional
          id={FLIGHT_CLASSES.BUSINESS}
          onClick={this.handleClassChange}
          disabled={!hasBusiness}
          className={cn('flight-class', {
            'flight-class--active': flightClass === FLIGHT_CLASSES.BUSINESS,
          })}
        >
          {`${
            hasBusiness
              ? i18n.t('checkout.flight.business.title')
              : i18n.t('checkout.flight.business.noTicket')
          }`}
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  flightClass: getFlightClass(state),
  economyCount: economyFlightsCountSelector(state),
  businessCount: businessFlightsCountSelector(state),
});

const mapDispatchToProps = {
  setFlightClass: changeFlightClassAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FlightClassSwitcher);
